import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { getCountries, getLanguages } from 'api/Languages';

export const fetchLanguages = createAsyncThunk(
    'fetchLanguages',
    async () => {
        const response = await getLanguages();
        return response.data;
    },
    {
        condition: (_, { getState }) => {
            // @ts-ignore
            const { languages } = getState().languageState;
            if (languages.length) return false;
        },
    },
);

export const fetchCountries = createAsyncThunk(
    'fetchCountries',
    async () => {
        const response = await getCountries();
        return response.data;
    },
    {
        condition: (_, { getState }) => {
            // @ts-ignore
            const { countries } = getState().languageState;
            if (countries.length) return false;
        },
    },
);

const languageSlice = createSlice({
    name: 'languageSlice',
    initialState: {
        language: {
            name: 'EN',
            icon: null,
            code: 'en',
        },
        country: {
            name: 'England',
            icon: null,
            code: 'en',
        },
        languages: [],
        countries: [],
    },
    reducers: {
        changeLanguage: (state, action) => {
            state.language = action.payload;
        },
        changeCountry: (state, action) => {
            state.country = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchLanguages.fulfilled, (state, action) => {
            state.languages = action.payload.data;
            state.language = action.payload.data[0];
        });
        builder.addCase(fetchCountries.fulfilled, (state, action) => {
            state.countries = action.payload.data;
            state.country = action.payload.data[0];
        });
    },
});

export const selectLanguageState = createSelector([state => state.languageState], data => data || {});

export const selectCurrentCountry = createSelector(
    [state => state.languageState],
    languageState => languageState.country,
);
export const selectCurrentLanguage = createSelector(
    [state => state.languageState],
    languageState => languageState.language,
);

export const selectActiveLanguageAndContry = createSelector(
    [selectCurrentCountry, selectCurrentLanguage],
    (country, language) => ({
        country,
        language,
    }),
);

export const { changeLanguage, changeCountry } = languageSlice.actions;

export default languageSlice.reducer;
